<template>
    <div class="f-official-less">
        <span class="f-official-less-tags">
            <span>{{OfficialBoardLabel.OfficialProcess.label}}:</span>
            <span class="f-official-less-name">
                {{officialinfo.process | matchOfficialProcess}}
            </span>
        </span>
        <span class="f-official-less-tags">
            <span>{{OfficialBoardLabel.DutyStaff.label}}:</span>

            <span v-if="Object.keys(officialinfo.followUserInfo).length">
                <img class="f-official-less-avatar"
                    :src="officialinfo.followUserInfo.avatar">
            </span>
            <span class="f-official-less-name">
                {{followUserName}}
            </span>
        </span>

        <!-- icafe链接 -->
        <div v-if="officialinfo.icafeUrl && officialinfo.icafeUrl.length"
            class="f-official-less-icafe-link">
            <span>{{OfficialBoardLabel.IcafeLink.label}}：</span>
            <a :href="officialinfo.icafeUrl"
                target="_blank">{{officialinfo.icafeUrl}}</a>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/less-info.less';
</style>

<script>
    import {mapState, mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapState({
                OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
                officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo
            }),
            ...mapGetters([
                'followUserName'
            ])
        }
    };
</script>
